export type OrderPlusSearch = {
    /** Source job id. */
    from?: string
}

export function validateOrderPlusSearch(search: Record<string, unknown>): OrderPlusSearch {
    return {from: typeof search['from'] === 'string' && search['from'] ? search['from'] : undefined}
}
